import { DocumentNode, gql } from '@apollo/client';

export const DatabaseServerOrPathFragmentGql: DocumentNode = gql`
fragment DatabaseServerOrPath on Database {
  __typename
  name
  ... on DatabaseServer {
    hostName
    port
  }
  ... on CloudFile {
    requestUrl
    fileId
    provider
  }
  ... on File {
    filePath
  }
  ... on WebDataConnector {
    connectorUrl
  }
}
`;
